import * as z from "zod/v4";

export const updateVariantBinMetafield = {
  name: "updateVariantBinMetafield" as const,

  input: z.object({
    variantId: z
      .string()
      .describe("The Shopify variant ID (can be numeric ID or GID)"),
    binValue: z
      .string()
      .describe("The bin location value to set in the custom.bin metafield"),
  }),

  output: z.object({
    success: z
      .boolean()
      .describe("Whether the metafield update was successful"),
    metafieldId: z
      .string()
      .optional()
      .describe("The ID of the updated metafield"),
    errors: z
      .array(z.string())
      .optional()
      .describe("Any errors that occurred during the update"),
  }),
};
